import React from "react";
import { FaDiscord, FaEnvelope, FaHeadset, FaComment, FaUsers } from "react-icons/fa";
import { motion } from "framer-motion";

import {
  Container,
  Content,
  Title,
  Cards,
  ContactCard,
  CardIcon,
  CardContent,
  SocialLinks
} from "./styles";

function ContactSection() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        when: "beforeChildren",
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.6 } },
  };

  return (
    <Container
      as={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      <Content>
        <Title as={motion.h2} variants={itemVariants}>
          Entre em contato
        </Title>

        <motion.p className="subtitle" variants={itemVariants}>
          Estamos prontos para ajudar. Escolha a forma mais conveniente para falar conosco.
        </motion.p>

        <Cards>
          <ContactCard 
            as={motion.div} 
            variants={itemVariants}
            whileHover={{ y: -8, transition: { duration: 0.2 } }}
          >
            <CardIcon className="discord">
              <FaDiscord />
            </CardIcon>
            <CardContent>
              <h3>Discord</h3>
              <p>Entre para nossa comunidade no Discord e tenha acesso ao suporte da equipe e recursos exclusivos.</p>
              <a 
                href="https://discord.gg/atlas" 
                target="_blank" 
                rel="noopener noreferrer"
                className="primary-btn"
              >
                Entrar no Discord
              </a>
            </CardContent>
          </ContactCard>

          <ContactCard 
            as={motion.div} 
            variants={itemVariants}
            whileHover={{ y: -8, transition: { duration: 0.2 } }}
          >
            <CardIcon className="email">
              <FaEnvelope />
            </CardIcon>
            <CardContent>
              <h3>Email</h3>
              <p>Possui dúvidas específicas? Envie-nos um email e nossa equipe responderá o mais breve possível.</p>
              <a 
                href="mailto:contato@atlasplugins.com" 
                className="secondary-btn"
              >
                Enviar Email
              </a>
            </CardContent>
          </ContactCard>

          <ContactCard 
            as={motion.div} 
            variants={itemVariants}
            whileHover={{ y: -8, transition: { duration: 0.2 } }}
          >
            <CardIcon className="support">
              <FaHeadset />
            </CardIcon>
            <CardContent>
              <h3>Suporte</h3>
              <p>Precisa de ajuda com algum plugin? Nossa equipe de suporte está disponível para auxiliar você.</p>
              <a 
                href="/suporte" 
                className="primary-btn"
              >
                Acessar Suporte
              </a>
            </CardContent>
          </ContactCard>
        </Cards>

        <SocialLinks as={motion.div} variants={itemVariants}>
          <h3>Siga-nos nas redes sociais</h3>
          <div className="links">
            <a href="https://twitter.com/atlasplugins" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://www.youtube.com/atlasplugins" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/atlasplugins" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </SocialLinks>
      </Content>
    </Container>
  );
}

export default ContactSection;
